import type { SxProps, Theme } from "@mui/material/styles";
import stepCardFill from "../../assets/step_card_fill.png";
import stepCardBorder from "../../assets/step_card_border.png";

export const cardContainerSx: SxProps<Theme> = {
  // Embla slide sizing - mobile: 85% width for peek effect, desktop: fixed width
  width: { xs: "100%", sm: "350px", "2xl": "450px" },
  minWidth: { xs: "280px", sm: "320px", md: "350px", "2xl": "450px" },
  maxWidth: { xs: "350px", "2xl": "450px" },
  // Cards stretch to match tallest card (via parent alignItems: stretch)
  // minHeight/maxHeight provide constraints
  minHeight: { xs: "250px", md: "400px", "2xl": "500px" },
  // maxHeight: { xs: "400px", md: "500px", "2xl": "700px" },
  flexShrink: 0,
  padding: {
    xs: "2rem 1.5rem",
    xl: "2rem 1.5rem 2rem",
    "2xl": "3.125rem",
  },
  display: "flex",
  flexDirection: "column",
  gap: { xs: "2rem", "2xl": "2.5rem" },
  color: "white",
  position: "relative",
  // Use filled PNG as mask for irregular shape
  maskImage: `url(${stepCardFill})`,
  maskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskImage: `url(${stepCardFill})`,
  WebkitMaskSize: "100% 100%",
  WebkitMaskRepeat: "no-repeat",
  // Background with backdrop blur
  backgroundColor: "rgba(217, 217, 217, 0.2)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  // Border using border-only PNG as mask, color controlled via CSS
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    maskImage: `url(${stepCardBorder})`,
    maskSize: "100% 100%",
    maskRepeat: "no-repeat",
    WebkitMaskImage: `url(${stepCardBorder})`,
    WebkitMaskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    backgroundColor: "grey",
    pointerEvents: "none",
    zIndex: 10,
  },
};

export const cardLabelSx: SxProps<Theme> = {
  padding: "1rem 2rem",
  borderRadius: "3.5rem",
  width: "fit-content",
  fontWeight: 500,
  color: "white",
  border: "1px solid #D9D9D94D",
  zIndex: 2,
};

export const cardScrollWrapperSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  // Prevent horizontal swipe when scrolling content vertically
  touchAction: "pan-y",
  // Styled scrollbar
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(255, 255, 255, 0.3) transparent",
  "&::-webkit-scrollbar": {
    width: "0.5rem",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(255, 255, 255, 0.3)",
    borderRadius: "0.25rem",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "rgba(255, 255, 255, 0.5)",
  },
};

export const cardContentSx: SxProps<Theme> = {
  alignItems: "start",
  gap: { xs: "1.5rem", sm: "1rem", "2xl": "3rem" },
  "& p": {
    fontSize: { xs: "1rem", xl: "1.2rem", "2xl": "1.5rem" },
  },
};

export const cardContentSectionSx: SxProps<Theme> = {
  gap: { xs: "1.5rem", "2xl": "3rem" },
};
